import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { URLS } from 'services/urls';
import { SignUpStage, SignUpStageData, useSignUpContext } from '../SignUpContext';
import { useSendPasswordResetEmail } from '../hooks';
import './EmailVerificationPage.scss';

interface EmailVerificationPageProps {
    email?: string;
    onBack?: () => void;
    isOverlay?: boolean;
}

const EmailVerificationPage: React.FC<EmailVerificationPageProps> = ({ email: emailProp, onBack, isOverlay = false }) => {
    const { currentStageData } = useSignUpContext();
    const { mutate: resendEmail, isPending: isResending } = useSendPasswordResetEmail();

    const email = emailProp || (currentStageData as SignUpStageData[SignUpStage.EMAIL_VERIFICATION])?.email || '';

    const redirectUrl = isOverlay
        ? `${window.location.origin}/account_created`
        : `${window.location.origin}/deals`;

    const handleResendEmail = () => {
        resendEmail(
            {
                email,
                redirect_url: redirectUrl,
            },
            {
                onError: error => {
                    console.error('Failed to resend email:', error);
                },
            },
        );
    };

    return (
        <div className={`EmailVerification ${isOverlay ? 'EmailVerification--overlay' : ''}`}>
            <img
                className="EmailVerification__background-image"
                src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/building_side_image.png')}
                alt="Background"
            />
            <div className="EmailVerification__container">
                {onBack && (
                    <button
                        type="button"
                        className="EmailVerification__back-button"
                        onClick={onBack}
                        data-testid="backButton"
                    >
                        <FontAwesomeIcon icon={faAngleLeft} className="mr-1 text-primary" />
                        <span className="text-primary font-weight-bold">Back</span>
                    </button>
                )}

                <div className="EmailVerification__icon">
                    <FontAwesomeIcon icon={faEnvelope} size="3x" />
                </div>

                <h1 className="EmailVerification__title">Verify your email</h1>

                <p className="EmailVerification__message">
                    We've sent you an email with a link to validate your email address and create your password.
                </p>

                <p className="EmailVerification__submessage">
                    Click the link in the email to complete your account setup and get started with Northspyre.
                </p>

                <div className="EmailVerification__resend">
                    <span className="EmailVerification__resend-text mt-3">
                        Didn't receive the email?
                    </span>
                    <NSButtonBase
                        callback={handleResendEmail}
                        disabled={isResending}
                        className="EmailVerification__resend-button text-primary"
                    >
                        {isResending ? 'Sending...' : 'Resend verification email'}
                    </NSButtonBase>
                </div>
            </div>
        </div>
    );
};

export default EmailVerificationPage;
